<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(multipleSelection)"
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
        <template #right>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
          <el-input
            placeholder="请输入关键字"
            size="mini"
            v-model="search.keyword"
            clearable
          >
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              title="搜索日志"
              @click="fetchData"
              slot="append"
            ></el-button>
          </el-input>
        </template>
      </east-operate>
    </template>
    <el-table
      :data="tableData.list"
      :empty-text="emptyText"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作内容"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="account"
        label="操作者"
        width="120"
      ></el-table-column>
      <el-table-column label="操作时间" width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.addTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="url"
        label="请求接口"
        min-width="240"
      ></el-table-column>
      <el-table-column
        prop="method"
        label="请求方式"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column prop="ip" label="操作IP" width="160"></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleView(scope.$index, scope.row)"
            >明细</el-button
          >
          <el-button size="mini" type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search.page"
        :page-sizes="$page.sizes"
        :page-size="search.size"
        layout="total, sizes, prev, pager, next"
        :total="tableData.total"
      >
      </el-pagination>
    </template>
    <!-- 明细 开始 -->
    <el-dialog
      custom-class="custom-dialog"
      title="日志明细"
      :visible.sync="viewShow"
    >
      <div class="dialog-main-box">
        <table>
          <tr>
            <td>操作内容：</td>
            <td>{{ viewData.operation }}</td>
          </tr>
          <tr>
            <td>操作用户：</td>
            <td>
              {{ viewData.account }} [{{ viewData.addTime | dateFormat }}]
            </td>
          </tr>
          <tr>
            <td>操作IP：</td>
            <td>{{ viewData.ip }}</td>
          </tr>
          <tr>
            <td>请求接口：</td>
            <td>{{ viewData.url }}</td>
          </tr>
          <tr>
            <td>请求来源：</td>
            <td>{{ viewData.referrer }}</td>
          </tr>
          <tr>
            <td>请求方式：</td>
            <td>{{ viewData.method }}</td>
          </tr>
          <tr>
            <td>请求参数：</td>
            <td>
              <el-input
                type="textarea"
                readonly
                resize="none"
                :autosize="{ minRows: 2, maxRows: 3 }"
              >
                {{ viewData.data }}
              </el-input>
            </td>
          </tr>
          <tr>
            <td>终端信息：</td>
            <td>
              <el-input
                type="textarea"
                readonly
                resize="none"
                :autosize="{ minRows: 2, maxRows: 3 }"
              >
                {{ viewData.agent }}
              </el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 明细 结束 -->
  </general-layout>
</template>
<script>
import LOG from "@/api/log";
import _ from "lodash";
export default {
  data() {
    return {
      search: {
        keyword: "",
        stime: "",
        etime: "",
        size: this.$page.size,
        page: 1
      },
      time: ["", ""],
      tableData: {},
      emptyText: " ",
      multipleSelection: [],
      viewShow: false,
      viewData: {},
      loading: true
    };
  },
  computed: {
    // ...mapState(['user'])
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    measure() {
      this.tableHeight = window.innerHeight - 185;
    },
    async fetchData() {
      if (this.time === null) {
        this.time = ["", ""];
      }
      this.search.stime = this.time[0] || "";
      this.search.etime = this.time[1] || "";

      let response = await LOG.LIST(this.search);
      if (response.data.state) {
        if (this.search.page === 1 || response.data.logs.list.length) {
          this.tableData = response.data.logs;
          this.loading = false;
        } else {
          this.search.page = 1;
          await this.fetchData();
        }
      }
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleDelete(logs) {
      logs = _.isArray(logs) ? logs : [logs];
      if (logs.length === 0) {
        this.$notify.warning({
          title: "提示",
          message: "请选择要删除的日志",
          duration: 1500
        });
      } else {
        try {
          await this.$confirm("删除不可恢复,确认?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            lockScroll: false
          });
          let ids = logs.map(l => l.id);
          let response = await LOG.DELETE({ ids });
          if (response.data.state) {
            this.$message.success("日志删除成功");
            await this.fetchData();
          } else {
            this.$message.error(response.data.message);
          }
          // eslint-disable-next-line no-empty
        } catch {}
      }
    },
    handleView(index, row) {
      this.viewData = row;
      this.viewShow = true;
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 200px;
  margin: 0 8px;
}
.custom-dialog {
  table {
    width: 100%;
    tr {
      line-height: 36px;
      td:first-child {
        width: 70px;
      }
    }
  }
}
</style>
